export default function Toggle({
  value,
  onChange,
  disabled = false,
  ariaLabel,
}: {
  value: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!value)}
      className={`relative h-5 w-9 rounded-full transition-colors duration-200 cursor-pointer shrink-0 focus:outline-none border ${
        value ? "border-transparent" : "border-gray-300"
      }`}
      style={{ backgroundColor: value ? "#830051" : "#ffffff" }}
    >
      <span
        className={`absolute top-0.5 left-0.5 h-3.5 w-3.5 rounded-full shadow-sm transition-transform duration-200 ${
          value ? "translate-x-4 bg-white" : "translate-x-0 bg-gray-400"
        }`}
      />
    </button>
  );
}
